import { useEffect, useState, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../lib/apiClient";
import ProductCard from "../components/ProductCard";

const CATEGORIES = [
  { key: "all", label: "ALL DROPS" },
  { key: "tees", label: "TEES" },
  { key: "hoodies", label: "HOODIES" },
  { key: "caps", label: "CAPS" },
  { key: "accessories", label: "GEAR" },
];

export default function Shop() {
  const [params, setParams] = useSearchParams();
  const cat = params.get("category") || "all";
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const q = cat !== "all" ? `?category=${cat}` : "";
    api.get(`/products${q}`).then((r) => setProducts(r.data)).finally(() => setLoading(false));
  }, [cat]);

  return (
    <div data-testid="shop-page" className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
      <div className="border-b border-white/20 pb-8 mb-10">
        <p className="text-blood text-xs tracking-[0.3em] font-mono mb-2">// CATALOG</p>
        <h1 className="font-anton uppercase text-bone text-5xl sm:text-7xl tracking-tighter">
          THE FULL <span className="text-blood">ARSENAL</span>
        </h1>
        <p className="text-ash text-sm mt-4 max-w-2xl">
          EVERY PIECE BUILT FOR THE STREETS. LIMITED RUNS. ONCE THEY'RE GONE, THEY'RE GONE.
        </p>
      </div>

      <div className="flex flex-wrap gap-3 mb-10">
        {CATEGORIES.map((c) => (
          <button
            key={c.key}
            data-testid={`category-filter-${c.key}`}
            onClick={() => {
              const next = new URLSearchParams(params);
              if (c.key === "all") next.delete("category");
              else next.set("category", c.key);
              setParams(next);
            }}
            className={`px-5 py-2 text-xs tracking-[0.2em] uppercase font-mono border transition-colors ${
              cat === c.key
                ? "bg-blood text-bone border-blood"
                : "border-white/20 text-bone hover:bg-bone hover:text-ink"
            }`}
          >
            {c.label}
          </button>
        ))}
      </div>

      {loading ? (
        <div data-testid="shop-loading" className="font-mono text-ash text-center py-20">
          <span className="text-blood animate-pulse">+ + +</span> LOADING DROP <span className="text-blood animate-pulse">+ + +</span>
        </div>
      ) : products.length === 0 ? (
        <div data-testid="shop-empty" className="font-marker text-blood text-3xl text-center py-20">
          nothing here, yet.
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {products.map((p, i) => (
            <ProductCard key={p.id} product={p} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}
